// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IUndergroundInfoSchema {
  /** ID метро **/
  id: number;
  /** Цвет линии метро, hex **/
  lineColor?: string;
  /** Название **/
  name: string;
  /** Год сдачи для строящейся станции **/
  releaseYear?: number;
  /** Время в пути в минутах до метро, мин **/
  travelTime: number;
  /** Способ передвижения до метро **/
  travelType: ETravelType;
  /** Является ли станция строящейся **/
  underConstruction?: boolean;
  /** Ссылка (ЧПУ) **/
  url?: string;
}
export enum ETravelType {
  /** На транспорте **/
  'Transport' = 'transport',
  /** Пешком **/
  'Walk' = 'walk',
}
